<template>
  <div
    id="HomeHeaderFixed"
    :class="{ 'on':isShow}"
  >
    <PublicHeader
      ref="PublicHeader"
      :is-show-search="true"
      :nav-type="COMMON.HEADER.NAV.TYPE.OTHER"
      @topTop="topTop"
      :isFixedHeader="true"
    />
  </div>
</template>

<script>
import {
  PublicHeader
} from "@/components/common/index.js";
import {COMMON} from "@/constant/COMMON";

export default {
  name: "HomeHeaderFixed",
  components: {
    PublicHeader
  },
  data() {
    return {
      isShow: false,
      COMMON
    }
  },
  mounted() {
    this.handleScroll()
    window.addEventListener("scroll", this.handleScroll);
    this.$store.commit('layout/SET_IS_SHOW_SEARCH', true)

  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.isShow = scrollTop > 300;
    },

    topTop() {
      window.scrollTo(0, 0);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "components/common/header/common/header";
</style>
